/* tslint:disable */
import { Component, OnInit, ViewChild } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators
} from '@angular/forms';
import 'rxjs/add/operator/map';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import 'rxjs/add/operator/map';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AngularFireStorage } from '@angular/fire/storage';
import { GenProvider } from 'src/providers/gen/gen';
import { Table } from 'primeng/table';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable'
import { Subscription } from 'rxjs/internal/Subscription';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-cargo',
  templateUrl: './cargo.component.html',
  styleUrls: ['./cargo.component.scss'],
  providers: [ConfirmationService]
})
export class CargoComponent implements OnInit {
  @ViewChild('dtLista') dtLista: Table;
  employees: Observable<[]>;
  mostraFrm: boolean = false;
  path: any;
  formulario: FormGroup;
  parametro: any;
  lista: any;
  titulo: string;
  cols: any = [];
  exportColumns: any = [];
  status: any = [];
  formulario_sub: FormGroup;
  subcargo: any;
  unSub: Subscription ;
  permissao: any = true;
  loading:any;
  constructor(
    private formBuilder: FormBuilder,
    private genProvider: GenProvider,
    private router: Router,
    public storage: AngularFireStorage,
    private messageService: MessageService,
    private confirmationService: ConfirmationService
  ) {
    this.path = this.genProvider.parametros.path;
    this.formulario = this.formBuilder.group({
      key: null,
      nome: [null, Validators.required],
      descricao: [null, Validators.required],
      status: [null, Validators.required],
    });

  }

  onClose() {
    this.router.navigate(['']);
  }

  onMostraFrm() {
    this.mostraFrm = !this.mostraFrm;
  }
  ngOnInit() {
    this.status = [
      { nome: 'Ativo' },
      { nome: 'Desativado' }
    ]
    this.cols = [
      { header: 'Código', field: 'key' },
      { header: 'Cargo', field: 'nome' },
      { header: 'Descrição', field: 'descricao' },
      { header: 'Status', field: 'status' }
    ];
    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));
    this.onLoad();
  }
  ngOnDestroy() {
    console.log("destroying child...")
  //  this.unSub.forEach(s => {
  //    s.unsubscribe();
  //  });
  }
  onLoad() {
    let i= 0
    this.loading = true

    this.unSub = this.genProvider.onGetAll('dados/' + this.path + '/cargo', "nome").subscribe( data => {
  //    this.unSub.unsubscribe();
      this.lista = JSON.parse(JSON.stringify(data));
      this.loading = false;
    });

  }

  onNovo() {
    this.formulario.reset();
    this.titulo = 'Nova';
    this.onMostraFrm();
    this.permissao = false;
  }
  onEdit(event: any) {
    this.formulario.reset();
    this.formulario.patchValue({
      key: event.key,
      nome: event.nome,
      descricao: event.descricao,
      status: event.status
    });
    this.titulo = 'Editar cargo';
    this.onMostraFrm();
    this.permissao = false;
  }

  onDeleteConfirm(event) {
    this.confirmationService.confirm({
      message: 'Confirma a Exclusão de ' + event.nome,
      header: 'Confirmação',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim',
      acceptIcon: 'pi pi-check',
      rejectLabel: 'Não',
      rejectIcon: 'pi pi-times',
      accept: () => {
        this.genProvider.remove('dados/' + this.path + '/cargo', event.key, 'key_cargo').then(res=>{
          if (res!=null){
            this.messageService.add({ severity: 'info', summary: 'Rejected', detail: 'Exclusão cancelada, este registro está relaciondo à '+ res +' tabelas!' });
          }else {
            this.messageService.add({ severity: 'info', summary: 'Confirmado', detail: 'Exclusão confirmada' });
          }
        })
      },
      reject: () => {
        this.messageService.add({ severity: 'info', summary: 'Rejected', detail: 'Exclusão cancelada' });
      }
    });

  }
  onSave() {
//this.genProvider.onSaveTeste();
    
    if (this.formulario.valid) {
      this.onSubmit();
    }
    
  }
  onSubmit() {
    this.onMostraFrm();
   // this.unSub.unsubscribe()
    this.genProvider.onSaveIncrement("dados/" + this.path + "/cargo", this.formulario.value, "cargo").then(t => {
      this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Dados Gravados.' });
      this.formulario.reset();
   //   this.onLoad()
    }).catch(e => {
      this.messageService.add({ severity: 'info', summary: 'Atenção!!', detail: 'Atenção, não foi possível enviar seus dados, por favor verifique a sua conexão de internet.' });
      console.log(e);
    });
    
  }
  exportPdf() {
    let lista: any;
    if (this.dtLista.filteredValue) {
      lista = this.dtLista.filteredValue
    } else {
      lista = this.lista
    }
    const doc = new jsPDF('p', 'mm', 'a4');
    doc.setFontType('normal');
    doc.setFont('arial');
    doc.setFontSize(25)
    doc.setFontType('bold');
    doc.text(14, 10, "Cargos")
    doc.setFontSize(7);
    doc.setFontStyle('normal');
    //doc.text("Periodo de " + new DatePipe("pt-BR").transform(this.inicio, "d, MMMM yyyy - HH:mm") + " à " + new DatePipe("pt-BR").transform(this.final, "d, MMMM yyyy - HH:mm"), 14, 15);
    doc.autoTable({
      //      columnStyles: {
      //       0: { halign: 'left', fillColor: [220, 220, 220] }
      //     },
      //      margin: { top: 20 },
      showFoot: 'lastPage',
      startY: 20,
      didDrawPage: (data) => {
        doc.text(data.pageNumber.toString(), data.cursor.x + 2, data.cursor.y + 2, 10, 10)
      },
      columns: this.exportColumns,
      body: lista,
      // foot: this.listaFoot
    });
    doc.save('lista.pdf');
  }
 }
